import { FC } from 'react';
import { Loader2 } from 'lucide-react';
import { CourseReview } from '../CourseReview/CourseReview';
import { useGetStudentCourseQuery, useGetStudentReviewsQuery } from '@teachur/http-client';
import { useVideoCallContext } from 'src/contexts/VideoCallProvider';

export const CourseInfoPanelWrapper: FC = () => {
  const { courseId, studentId, videoCallId } = useVideoCallContext();

  const { data, isLoading } = useGetStudentCourseQuery(courseId, studentId);
  const { data: reviews = [] } = useGetStudentReviewsQuery(courseId, studentId, {
    enabled: !!courseId && !!studentId,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-6 h-6 animate-spin text-neutral-400" />
      </div>
    );
  }

  if (!data?.course || !studentId || !videoCallId) {
    return (
      <div className="flex items-center justify-center h-64 p-4">
        <p className="text-neutral-500 text-sm">No course data available</p>
      </div>
    );
  }

  const { course } = data;

  if (!course.goals?.length) {
    return (
      <div className="p-4">
        <h3 className="text-lg font-bold text-neutral-900">{course.name}</h3>
        <p className="text-sm text-red-500 mt-4">
          This course does not have any grade rubric. Please add goals to the course.
        </p>
      </div>
    );
  }

  return (
    <CourseReview
      course={data.course}
      userCourse={data.userCourse}
      studentId={studentId}
      notes={data.notes}
      reviews={reviews}
      scheduledCallId={videoCallId}
    />
  );
};
